import { render, staticRenderFns } from "./VuetifyConfirm.vue?vue&type=template&id=3c16b1dc"
import script from "./VuetifyConfirm.vue?vue&type=script&lang=ts"
export * from "./VuetifyConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports